import { useCardsQuery } from 'hooks/queries/Cards/useCardsQuery'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { useMappedRoles } from 'hooks/useMappedRoles'
import { Card, CardStatus } from 'services/CardService'
import { luceneField } from 'utils/lucene'

const STATUS_PRIORITY: CardStatus[] = ['ACTIVE', 'FROZEN', 'BLOCKED', 'PENDING']

const selectPreferredCard = (cards: Card[] | undefined): Card | undefined => {
  if (!cards?.length) return undefined

  for (const status of STATUS_PRIORITY) {
    const match = cards.find(card => card.status === status)
    if (match) return match
  }

  return cards[0]
}

export const useCustomerCards = (customerId: string) => {
  const { enableCards } = useFeatureFlags()
  const { canView: canViewCards } = useMappedRoles()?.cards || {}

  const { data, isLoading, isError } = useCardsQuery(
    { q: luceneField('customerId', customerId) },
    !!enableCards && !!canViewCards && !!customerId
  )

  return {
    card: selectPreferredCard(data?.content),
    cards: data?.content,
    isLoading,
    isError,
  }
}
